// extracted by mini-css-extract-plugin
module.exports = {"root":"WorkLookLayout_root__2RtV2","header":"WorkLookLayout_header__2oohD","sidebar":"WorkLookLayout_sidebar__2AWhx","content":"WorkLookLayout_content__oaT9M"};